export function initFlipTiles() {
  document.querySelectorAll('.c-flip-tile').forEach(initFlipTile);
}

function initFlipTile(tile) {
  if (!tile) return;

  let force = false;

  if (document.body.classList.contains('neos-backend')) {
    tile.querySelectorAll('.icon-exchange').forEach((toggle) =>
      toggle.addEventListener(
        'click',
        function () {
          force = !force;
          flip(force);
        },
        { passive: true }
      )
    );
  } else {
    tile.addEventListener(
      'click',
      () => flip(!tile.classList.contains('flip')),
      { passive: true }
    );

    tile.addEventListener('mouseenter', () => flip(true, 'mouse'), {
      passive: true,
    });

    tile.addEventListener('mouseleave', () => flip(false, 'mouse'), {
      passive: true,
    });
  }

  function flip(force, caller = 'click') {
    const isMobile = window.matchMedia('(hover: none)').matches;
    if (isMobile && caller !== 'click') return;
    tile.classList.toggle('flip', force);
  }
}
